import { useMemo } from "react";
import { Field, Select, TextInput } from "../ui/controls";
import { YouTubeLink } from "../ui/YouTubeLink";
import { ScoreLink } from "../ui/ScoreLink";

const CURATED = [
  "Messe de Saint Jean",
  "Messe du Peuple de Dieu",
  "Messe de la Réconciliation",
  "Messe d'Emmaüs",
  "Messe Soleil des Nations",
  "Messe de Saint Boniface",
];
const FREE = "__free__";

export function OrdinaryPicker({
  value,
  ordinaries,
  onChange,
  hint,
}: {
  value: string;
  ordinaries: string[];
  onChange: (v: string) => void;
  hint?: string;
}) {
  const known = useMemo(() => {
    const seen = new Set<string>();
    const list: string[] = [];
    for (const o of [...ordinaries, ...CURATED]) {
      const k = (o || "").trim();
      if (k && !seen.has(k.toLowerCase())) {
        seen.add(k.toLowerCase());
        list.push(k);
      }
    }
    return list;
  }, [ordinaries]);

  const isKnown = known.includes(value);

  return (
    <Field
      label="Ordinaire de la messe"
      action={
        <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
          <ScoreLink title={value} />
          <YouTubeLink title={value} />
        </div>
      }
      hint={hint}
    >
      <Select value={isKnown ? value : FREE} onChange={(v) => onChange(v === FREE ? "" : v)}>
        {known.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
        <option value={FREE}>✎ Autre (saisir un nom)…</option>
      </Select>
      {!isKnown && (
        <div style={{ marginTop: 8 }}>
          <TextInput value={value} placeholder="Nom de la messe (ordinaire)" onChange={onChange} />
        </div>
      )}
    </Field>
  );
}
